
import { Component, Vue } from 'vue-property-decorator';
import { PvdLink } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import LearnMorePopover from '../popovers/LearnMorePopover.vue';
import Popover from '../popovers/Popover.vue';
import { ClientConstants } from '../../client.constants';

@Component({ components: { LearnMorePopover, Popover } })
export default class HeadingBlock extends Vue {
    clientConstants = ClientConstants;

    mounted() {
        (this.$refs['tc-popover'] as Popover).setTarget(this.$refs['tc-popover-trigger'] as PvdLink);
        (this.$refs['lm-popover'] as Popover).setTarget(this.$refs['lm-popover-trigger'] as PvdLink);
    }

    openLearnMorePopover(): void {
        (this.$refs['lm-popover'] as LearnMorePopover).openModal();
    }

    openTermsAndConditionsPopover(): void {
        (this.$refs['tc-popover'] as Popover).openModal();
    }
}
